import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { checkPatientStatus } from "@/api/patients";
import { ROUTES } from "@/router";
import { useMultiStepFormStore } from "@/stores";
import { PATIENT_STATUS } from "@/utils";

interface CheckPatientVars {
  firstName: string;
  lastName: string;
  birthdate: string;
}

export const useCheckPatientStatus = () => {
  const { goToNextFormStep } = useMultiStepFormStore();
  const navigate = useNavigate();
  return useMutation({
    mutationFn: ({ firstName, lastName, birthdate }: CheckPatientVars) =>
      checkPatientStatus(firstName, lastName, birthdate),
    onSuccess: (response) => {
      switch (response.status) {
        case PATIENT_STATUS.NEW_PATIENT:
          goToNextFormStep();
          break;
        case PATIENT_STATUS.ACTIVE:
          void navigate(ROUTES.activePatient);
          break;
        case PATIENT_STATUS.DISQUALIFIED:
          void navigate(ROUTES.disqualifiedPatient, {
            state: { patientData: response },
          });
          break;
        case PATIENT_STATUS.TRANSFERRED:
          void navigate(ROUTES.transferredPatient, {
            state: { patientData: response },
          });
          break;
        default:
          goToNextFormStep();
      }
    },
  });
};
